import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
// TODO(incentive-budgets): re-import and use `Permission` once the
// incentive_budgets.view / .modify permissions are registered in backend RBAC
// (see the commented permission gates below).
// import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const incentiveBudgetsViewAccessControl: DomainAccessControlConfig = {
  // TODO(incentive-budgets): restore the permission gate before merging. The
  // `incentive_budgets.view` permission is not yet registered in backend RBAC, so
  // gating on it locks everyone out. Until RBAC is wired, gate on the feature
  // toggle alone for local/staging testing.
  // permissions: [Permission.IncentiveBudgetsView],
  featureToggles: [FeatureToggle.IncentiveBudgets],
}

export const incentiveBudgetsModifyAccessControl: DomainAccessControlConfig = {
  // TODO(incentive-budgets): restore the permission gate before merging. Like
  // `incentive_budgets.view`, the `incentive_budgets.modify` permission is not
  // yet registered in backend RBAC — gating on it makes `canModify` false for
  // everyone, which hides the MultiplierInputPanel (the override "bottom row")
  // entirely. Gate on the feature toggle alone until RBAC is wired, then restore
  // the permission to re-enforce the view/modify split.
  // permissions: [Permission.IncentiveBudgetsModify],
  featureToggles: [FeatureToggle.IncentiveBudgets],
}
